<template>
  <el-popover
    v-model="visible"
    placement="bottom-start"
    :width="360"
    trigger="manual"
    popper-class="address-book-input-popper"
    @show="loadAddressBooks"
  >
    <div ref="panel" class="address-book-panel" @click.stop>
      <el-input
        v-model.trim="keyword"
        clearable
        prefix-icon="el-icon-search"
        placeholder="搜索地址名称或详细地址"
        @input="searchAddressBooks"
        @clear="loadAddressBooks"
      />
      <div class="address-book-panel__actions">
        <el-button icon="el-icon-refresh" @click="loadAddressBooks">刷新</el-button>
        <el-button v-permission="'address:add'" type="primary" icon="el-icon-plus" @click="createAddressBook">新增地址收藏点</el-button>
      </div>
      <div v-loading="loading" class="address-book-panel__list">
        <div v-for="item in items" :key="item.id" class="address-book-panel__item" @click="selectAddressBook(item)">
          <div class="address-book-panel__name">{{ item.poiName }}</div>
          <div class="address-book-panel__detail">{{ item.areaName || '' }}{{ item.address || '' }}</div>
        </div>
        <el-empty v-if="!loading && !items.length" :image-size="56" description="暂无地址簿记录" />
      </div>
    </div>
    <div ref="reference" slot="reference" class="address-book-input" :class="{ 'address-book-input--button': buttonMode }" @click.stop>
      <el-button v-if="buttonMode" plain :aria-expanded="visible" @click="toggle">地址簿<i class="el-icon-arrow-down" /></el-button>
      <el-input
        v-else
        :value="value"
        :placeholder="placeholder"
        clearable
        @input="$emit('input', $event)"
      >
        <i slot="suffix" class="el-icon-arrow-down address-book-input__toggle" :class="{ 'is-open': visible }" @click.stop="toggle" />
      </el-input>
    </div>
  </el-popover>
</template>

<script>
import { getAddressBookList, isRequestSuccess } from './lingdongApi'

export default {
  name: 'AddressBookInput',
  props: {
    buttonMode: Boolean,
    value: { type: String, default: '' },
    placeholder: { type: String, default: '请输入详细地址' }
  },
  data() {
    return {
      visible: false,
      loading: false,
      requestId: 0,
      keyword: '',
      items: [],
      searchTimer: null
    }
  },
  beforeDestroy() {
    this.requestId += 1
    if (this.searchTimer) clearTimeout(this.searchTimer)
    document.removeEventListener('click', this.onDocumentClick)
  },
  mounted() {
    document.addEventListener('click', this.onDocumentClick)
  },
  methods: {
    toggle() {
      this.visible = !this.visible
    },
    onDocumentClick(event) {
      if (!this.visible) return
      const target = event.target
      if ((this.$refs.reference && this.$refs.reference.contains(target)) || (this.$refs.panel && this.$refs.panel.contains(target))) return
      this.visible = false
    },
    searchAddressBooks() {
      if (this.searchTimer) clearTimeout(this.searchTimer)
      this.requestId += 1
      this.searchTimer = setTimeout(() => this.loadAddressBooks(), 250)
    },
    async loadAddressBooks() {
      const requestId = ++this.requestId
      this.loading = true
      try {
        const res = await getAddressBookList({ poiName: String(this.keyword || '').trim(), enabled: 1, page: 1, limit: 12 })
        if (requestId !== this.requestId) return
        if (!isRequestSuccess(res)) throw new Error(res.msg || '查询地址簿失败')
        this.items = (res.data && res.data.items) || []
      } catch (e) {
        if (requestId !== this.requestId) return
        this.items = []
        this.$message.error(e.msg || e.message || '查询地址簿失败')
      } finally {
        if (requestId === this.requestId) this.loading = false
      }
    },
    selectAddressBook(item) {
      this.$emit('select', item)
      this.visible = false
    },
    createAddressBook() {
      this.visible = false
      this.$emit('create')
    }
  }
}
</script>

<style scoped>
.address-book-input { flex: 1; min-width: 0; width: 100%; }
.address-book-input--button > .el-button { height: 38px; margin: 0; padding: 0 10px !important; border: 0; border-radius: 0; line-height: 38px; background: transparent; }
.address-book-input__toggle { display: inline-flex; align-items: center; height: 100%; padding: 0 8px; color: #909399; cursor: pointer; transition: transform .2s; }
.address-book-input__toggle.is-open { transform: rotate(180deg); }
</style>

<style>
.address-book-input-popper { padding: 0; }
.address-book-panel { padding: 10px; }
.address-book-panel__actions { display: flex; gap: 8px; margin: 8px 0; }
.address-book-panel__actions .el-button { flex: 1; margin: 0; }
.address-book-panel__actions .el-button { padding: 8px 6px; font-size: 12px; }
.address-book-panel__list { max-height: 220px; overflow-y: auto; border-top: 1px solid #ebeef5; }
.address-book-panel__item { display: flex; align-items: baseline; gap: 10px; min-height: 42px; padding: 0 6px; color: #303133; cursor: pointer; }
.address-book-panel__item:hover { background: #f5f8ff; }
.address-book-panel__name { flex: 0 0 105px; overflow: hidden; color: #303133; font-size: 14px; font-weight: 600; line-height: 42px; text-overflow: ellipsis; white-space: nowrap; }
.address-book-panel__detail { flex: 1; overflow: hidden; color: #98a2b3; font-size: 12px; line-height: 18px; text-overflow: ellipsis; white-space: nowrap; }
.address-book-panel__list .el-empty { padding: 12px 0; }
</style>
